<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addStudentAndClassTypeDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <!--课时类型-->
        <el-form-item prop="classTypeId" label="班级类型:">
          <el-select
            v-model="form.classTypeId"
            multiple
            collapse-tags
            placeholder="请选择班级类型"
          >
            <el-option
              v-for="item in this.classTypeList.classTypeList"
              :key="item.text"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import {
  addStudentAndClassType,
  addMultipleStudentAndClassType,
} from "@/api/studentclasstype";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    let validateClassHour = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("课时增加/减少不能为空"));
      } else {
        var reg = /^\+|-/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的格式(+1|-1)"));
        } else {
          callback();
        }
      }
    };
    return {
      isVisible: this.isShow,
      selectDisabled: false,
      form: {
        id: "",
        stdId: "",
        classTypeId: "",
      },
      classHourType: [
        { label: "通用课时", value: "0" },
        { label: "启蒙课时", value: "1" },
      ],
      form_rules: {
        type: [
          { required: true, message: "自定义条目不能为空", trigger: "blur" },
        ],
        classhourType: [
          { required: true, message: "课时类型不能为空", trigger: "blur" },
        ],
        classhours: [
          { required: true, message: "课时增加/减少不能为空", trigger: "blur" },
          { validator: validateClassHour },
        ],
        opreateDate: [
          { required: true, message: "日期不能为空", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    stdId: String,
    classTypeList: Object,
  },
  computed: {
    ...mapGetters([
      "addStudentAndClassTypeDialog",
      "studentAndClassTypeSearch",
    ]),
  },
  created() {},
  mounted() {
    // console.log("初始");
    // console.log(this.studentAndClassTypeSearch.stdId);
    if (this.addStudentAndClassTypeDialog.type === "edit") {
      // console.log(this.dialogRow);
      this.form = this.dialogRow;
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          var classTypeIdStr = "";
          formData.classTypeId.forEach((value) => {
            classTypeIdStr = classTypeIdStr + value + ",";
          });
          const para = {
            stdId: this.studentAndClassTypeSearch.stdId,
            classTypeId: classTypeIdStr,
          };
          console.log(para);
          // edit
          if (this.addStudentAndClassTypeDialog.type === "edit") {
          } else {
            // add
            addMultipleStudentAndClassType(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增学员班级类型操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getClassHourList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
